(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luke-product-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const connect = () => {
    const section = document.getElementById('luke-product-reviews');
    if (!section) return;
    const productId = section.dataset.productId;
    document.querySelectorAll('.jdgm-preview-badge').forEach(badge => {
      if (badge.dataset.id !== productId || badge.closest('product-card')) return;
      if (badge.dataset.lukeProductReviewLink) return;
      badge.dataset.lukeProductReviewLink = 'true';
      badge.setAttribute('role', 'link');
      badge.setAttribute('tabindex', '0');
      badge.setAttribute('aria-controls', 'luke-product-reviews');
      const go = (event) => {
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const heading = document.getElementById('luke-product-reviews-heading');
        heading.focus({ preventScroll: true });
        heading.scrollIntoView({ behavior: 'instant', block: 'start' });
        history.replaceState(null, '', '#luke-product-reviews');
      };
      badge.addEventListener('click', go, true);
      badge.addEventListener('keydown', go, true);
    });
  };
  connect();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, { once: true });
  document.addEventListener('shopify:section:load', connect);
  window.addEventListener('load', connect, { once: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
